import { useSitecoreContext } from 'hooks/useSitecoreContext';
import RiskWarningContent from 'components/Sections/RiskWarning/RiskWarningContent';
import { useSelector, useDispatch } from 'react-redux';
import { getAmount } from '@/store/global';
import { globalActions } from '@/store/global';
import styles from './RiskWarning.module.scss';

import { useEffect, useMemo } from 'react';
import { RiskWarningFields } from './RiskWarning.types';
import { ComponentProps } from 'lib/component-props';
import classNames from 'classnames';

export type RiskWarningProps = Partial<ComponentProps> & {
  fields: RiskWarningFields;
};

const RiskWarning = ({ fields, rendering }: RiskWarningProps) => {
  const { sitecoreContext } = useSitecoreContext();
  const isExperienceEditor = sitecoreContext.pageEditing;
  const amountOfRiskWarningElements = useSelector(getAmount);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(globalActions.increment());

    return () => {
      dispatch(globalActions.decrement());
    };
  }, [dispatch]);
  const inBody = useMemo(() => {
    return !!rendering?.params;
  }, [rendering?.params]);

  return (
    <>
      {(inBody || isExperienceEditor) && (
        <section
          className={classNames('short-section my-4 my-xl-7', {
            'padding-zero': !inBody && isExperienceEditor,
            [styles['risk-warning']]: true,
          })}
          data-e2e-component-uid={rendering?.uid}
        >
          <RiskWarningContent rendering={rendering} fields={fields} />
        </section>
      )}
      {((!inBody && amountOfRiskWarningElements === 1) || isExperienceEditor) && (
        <RiskWarningContent
          rendering={rendering}
          fields={fields}
          data-e2e-component-uid={rendering?.uid}
        />
      )}
    </>
  );
};

export default RiskWarning;
